export const ru = {
    'empty-priority': 'Не указан',
    title: 'Редактирование приоритета автобюджета'
};
